import { useEffect, useState } from "react";
import { ChevronDown, FileText, Hash, ShieldCheck, ShieldX } from "lucide-react";
import { http } from "@/lib/api";

const Names = ({ id, label, Icon, rows }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`bf-ca-group is-${id}`} data-testid={`bf-ai-group-${id}`}>
      <div className="bf-ca-head">
        <Icon size={18} /><div><b>{label}</b></div>
        <span className="bf-ca-count" data-testid={`bf-ai-count-${id}`}>{rows.length}</span>
        <button type="button" className="st-btn st-btn--ghost" onClick={() => setOpen(!open)} disabled={!rows.length} data-testid={`bf-ai-toggle-${id}`}>
          {open ? "Ascunde" : "Arată"} <ChevronDown size={14} className={open ? "is-up" : ""} />
        </button>
      </div>
      {open && <ul className="bf-ca-list" data-testid={`bf-ai-list-${id}`}>{rows.map((r, i) => <li key={i}><div><b>{r.salon || r.title}</b><span>{r.city || (r.at && new Date(r.at).toLocaleDateString("ro-RO"))}</span></div></li>)}</ul>}
    </div>
  );
};

export default function BFAgentContractInfo() {
  const [d, setD] = useState(null);
  useEffect(() => { http.get("/bf/contracts/agent-info").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (!d) return null;
  return (
    <section className="invite-box bf-ca" data-testid="bf-agent-contract-info">
      <h3><ShieldCheck size={18} /> GDPR, documente și seria ta</h3>
      <p className="st-hint" data-testid="bf-ai-series">{d.series ? <><Hash size={13} /> Seria ta de contracte: <b>{d.series.code}</b> · {d.series.seq} contracte numerotate</> : "Seria ta de contracte se creează la primul contract semnat."}</p>
      <div className="bf-ca-groups">
        <Names id="gdpr_ok" label="Clienți cu GDPR semnat" Icon={ShieldCheck} rows={d.gdpr_ok} />
        <Names id="gdpr_missing" label="Clienți fără GDPR semnat" Icon={ShieldX} rows={d.gdpr_missing} />
        <Names id="docs" label="Documente GDPR generale" Icon={FileText} rows={d.docs} />
      </div>
    </section>
  );
}
